export const flyerAgeGroupKeyPrefix =
  'descriptions.admin-portal.workshops.details.actions.download-flyer.flyer.age-group';
